import { render, staticRenderFns } from "./PwaInstallAwardPopup.vue?vue&type=template&id=0242075a&scoped=true&"
import script from "./PwaInstallAwardPopup.vue?vue&type=script&lang=js&"
export * from "./PwaInstallAwardPopup.vue?vue&type=script&lang=js&"
import style0 from "./PwaInstallAwardPopup.vue?vue&type=style&index=0&id=0242075a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0242075a",
  null
  
)

export default component.exports